var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "relative w-full" }, [
    _c(
      "div",
      {
        staticClass:
          "absolute inset-0 flex items-center justify-center transition-opacity duration-300 z-20 pointer-events-none",
        class: { "opacity-100": _vm.loading, "opacity-0": !_vm.loading },
      },
      [_c("LoaderSpinner", { staticClass: "w-6 h-6" })],
      1
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "transition-opacity duration-300",
        class: { "opacity-0": _vm.loading, "opacity-100": !_vm.loading },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }